export
const name: string = "HudTexture";

export
const preproc: string = ``;

export
const declaration: string = `
    // Mode 2 -- texture
    uniform sampler2D   u_texture0;
    uniform float       u_alpha;
`;

export
const varyings: string = `
    varying vec2        v_texcoords;
`;

export
const implementation: string = `
    void main()
    {
        vec4 color = texture2D(u_texture0, vec2(v_texcoords.x, 1.0 - v_texcoords.y));
        color.a *= u_alpha;
        gl_FragColor = color;
    }
`;
